import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { UtilsService } from '../../../core/services/utils.service';
import { DocumentComponent } from '../document/document.component';
import { SharedModule } from '../../../shared/shared.module';
import { DocumentModel } from '../../../core/modules/documents/documents.types';
import { DOCUMENTS_PAGE_SIZE } from '../documents-page/documents-page.config';

@Component({
  selector: 'tax-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.sass'],
  imports: [
    SharedModule,
    DocumentComponent,
    NgIf,
    NgForOf,
  ],
  standalone: true,
})
export class DocumentListComponent {
  @Input() documents: DocumentModel[] = [];
  @Input() countDisplayedDocuments = DOCUMENTS_PAGE_SIZE;
  @Output() changePageSize = new EventEmitter<void>();

  readonly trackById: TrackByFunction<DocumentModel> = this.utilsService.trackById;
  constructor(private utilsService: UtilsService) {}

  loadMoreDocuments(): void {
    this.changePageSize.emit();
  }
}
